'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List, Map as ImmutableMap } from 'immutable';
import CampaignInfoRecord from 'AdsUI/records/ad-management/CampaignInfoRecord';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.CAMPAIGN_INFO_FETCH_SUCCEEDED:
      {
        const {
          network,
          accountId,
          campaigns
        } = payload;

        if (!campaigns) {
          return state;
        }

        return state.setIn([network, accountId], List(campaigns.map(campaign => new CampaignInfoRecord(Object.assign({}, campaign, {
          network
        })))));
      }

    default:
      {
        return state;
      }
  }
});